import tick from "./waiters.utils";

export const playNotificationSound = async () => {
  await tick();
}